export default "__VITE_ASSET__E0k31Z1p__"